module.exports = __webpack_public_path__ + "img/H & A Classroom.305050d7.jpg";